import { useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
// import LAutomation from "src/components/Landing/automation";
// import LBranding from "src/components/Landing/branding";
// import LBuy from "src/components/Landing/buy";
// import LDoYouKnow from "src/components/Landing/doYouKnow";
// import LFall from "src/components/Landing/fall";
// import LFeature from "src/components/Landing/feature";
import LFeature2 from "src/components/Landing/feature2";
import LFooter from "src/components/Landing/footer";
// import LHero1 from "src/components/Landing/hero1";
// import LHero2 from "src/components/Landing/hero2";
import LHero3 from "src/components/Landing/hero3";
import LInstaBuyAuto from "src/components/Landing/instaBuyAuto";
import LInstaComment from "src/components/Landing/instaComment";
import LInstaFollow from "src/components/Landing/instaFollow";
import LInstaLike from "src/components/Landing/instaLike";
import LInstaView from "src/components/Landing/instaView";
import LProduct from "src/components/Landing/product";
import LQuestions from "src/components/Landing/questions";
import LQuote from "src/components/Landing/quote";
// import LRealityFollower from "src/components/Landing/realityFollower";
// import LRealityFollower2 from "src/components/Landing/realityFollower2";
// import LSafe from "src/components/Landing/Safe";
// import LSupportPhone from "src/components/Landing/supportPhone";
// import LWarranty from "src/components/Landing/warranty";
import LWhatsapp from "src/components/Landing/whatsapp";
import Login from "src/components/Login";
import Section01WhiteLable02 from "src/components/NewDesign/Public/HomePage/Section01";
import Section02WhiteLable02 from "src/components/NewDesign/Public/HomePage/Section02";
import { queryParse } from "src/shared/function/queryParse";
import useAuth from "src/shared/hooks/useAuth";
import useDomain from "src/shared/hooks/useDomain";
import useSWR from "swr";
import "./index.less";

const landing1 = (
  <>
    {/* <LHero1 />
    <LBranding />
    <LBuy />
    <LQuote />
    <LRealityFollower />
    <LFall />
    <LSupportPhone />
    <LAutomation />
    <LQuestions />
    <LApplication />
    <LFooter /> */}
  </>
);

const landing2 = (
  <>
    {/* <LHero2 />
    <LBranding />
    <LProduct />
    <LDoYouKnow />
    <LQuote />
    <LRealityFollower2 />
    <LSafe />
    <LWarranty />
    <LFeature />
    <LWhatsapp />
    <LApplication />
    <LFooter /> */}
  </>
);

const Home = () => {
  const {
    location: { search },
    push,
  } = useHistory();
  const query = queryParse(search);
  const { landing, id: domainId } = useDomain();
  const { isLogedIn } = useAuth();
  useEffect(() => {
    if (domainId) {
      if (landing == "1" || !landing) {
        push("/panel");
      }
    }
  }, [landing]);

  const { data } = useSWR(`/product/landingInstagram`);

  const landing3 = (
    <div className="landing">
      <LHero3 />
      <LProduct data={data} />
      <LInstaFollow
        data={data
          ?.filter((item: any) => item.subCategoryName == "فالوور ایرانی")
          .sort((a: any, b: any) => a.quantity - b.quantity)}
        id="instaFollow"
      />
      <LInstaView
        data={data
          ?.filter(
            (item: any) =>
              item.subCategoryName == "بازدید ویدیو" ||
              item.subCategoryName == "بازدید لایو" ||
              item.subCategoryName == "بازدید IGTV"
          )

          .sort((a: any, b: any) => a.quantity - b.quantity)}
        id="instaView"
      />
      <LInstaLike
        data={data
          ?.filter((item: any) => item.subCategoryName == "لایک ایرانی")
          .sort((a: any, b: any) => a.quantity - b.quantity)}
        id="instaLike"
      />
      <LInstaComment
        data={data
          ?.filter((item: any) => item.subCategoryName == "کامنت")
          .sort((a: any, b: any) => a.quantity - b.quantity)}
        id="instaComment"
      />
      <LInstaBuyAuto />
      <LQuote />
      <LFeature2 />
      <LQuestions />
      <LWhatsapp />
      {/* <LApplication /> */}
      <LFooter />
    </div>
  );

  const landing3new = (
    <>
      <Section01WhiteLable02 />
      <Section02WhiteLable02 />
    </>
  );

  return query?.lol == true && !isLogedIn ? (
    <Login />
  ) : (
    <div style={{ textAlign: "right" }}>
      {(function () {
        switch (landing) {
          case "2":
            return landing3;
          case "3":
            return landing3new;
          default:
            return landing3;
            break;
        }
      })()}
    </div>
  );
};

export default Home;
